import { makeStyles } from "@mui/styles";
import { Bold, SemiBold } from "../../utils";

export const serviceStyles = makeStyles((theme) => ({

    main: {
        fontFamily: Bold,
        fontSize: "1rem",
        color: theme.typography.color.primary
    },
    sub: {
        fontSize: "0.875rem",
        color: theme.typography.color.primary,
        margin: "12px 0px",
        fontFamily: SemiBold
    },
    btn: {
        backgroundColor: "white",
        padding: "12px",
        color: theme.palette.primary.main,
        textTransform: "none",
        fontFamily: Bold,
        "&:hover": {
            backgroundColor: "white",

        }
    },
    grid: {
        textAlignLast: "center"
    }

}))